import { cn } from '@/lib/utils'

export function HeroWrapper({
  children,
  className,
  onClick
}: {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}) {
  return (
    <div
      className={cn(
        'min-w-0 flex-shrink-0 flex-grow-0 basis-full overflow-hidden lg:h-[700px]',
        className
      )}
      onClick={onClick}
    >
      <div className="mx-auto flex h-full w-full max-w-[1440px] flex-col items-center space-y-4 px-4 pt-6 text-center md:justify-between lg:flex-row lg:gap-8 lg:text-left">
        {children}
      </div>
    </div>
  )
}
